import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Collapse,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Step,
  StepLabel,
  Stepper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import toast from "react-hot-toast";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import { getVendorsList } from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import formatDateAndTime from "../../common/formatDateAndTime";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useSelector } from "react-redux";
import { FileText, FileVideo, FileImage, File } from "lucide-react";
import HeicPreview from "../../common/HeicPreview";

function createData(
  attachments,
  city,
  serviceDate,
  ododmeterReading,
  description,
  isRotated,
  isAlignmentDone,
  isBalancingDone,
  isPaymentPending,
  costToCompany,
  totalCost,
  issueId,
  vendorName,
  rawData,
) {
  return {
    attachments,
    city,
    serviceDate,
    ododmeterReading,
    description,
    isRotated,
    isAlignmentDone,
    isBalancingDone,
    isPaymentPending,
    costToCompany,
    totalCost,
    issueId,
    vendorName,
    rawData,
  };
}

const steps = ["Wheel Alignment Log Details"];

const Wheelalignmentlogs = ({ handleImageOpen, selectedRow }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const cities = useSelector((state) => state?.cities?.citiesData);
  const catalogValues = JSON.parse(localStorage.getItem("catalogValues"));

  const clutchPartName = catalogValues?.clutchPartName || {};
  delete clutchPartName?.inverted;
  const clutchPartSource = catalogValues?.clutchPartSource || {};
  delete clutchPartSource?.inverted;
  const clutchWorkType = catalogValues?.clutchWorkType || {};
  delete clutchWorkType?.inverted;
  const [activeStep, setActiveStep] = useState(0);
  const [hideTextfields, setHideTestFields] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [clutchLogs, setClutchLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [myIssues, setMyIssuesDetails] = useState([]);

  const getVehicleIssues = async (vehicleID) => {
    try {
      setLoading(true);

      const response = await fetch(
        `${apiUrl}/api/vehicleissues?limit=${200}&offset=${0}&vehicleId=${vehicleID}`,
        {
          method: "GET",
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setMyIssuesDetails(data?.entities?.rows || []);
      }

      return data;
    } catch (error) {
      console.error("Error fetching NRK listings:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getVendorListAPI();
  }, []);

  useEffect(() => {
    if (selectedRow?.id) {
      getVehicleIssues(selectedRow.id);
    }
  }, [selectedRow]);

  const getVendorListAPI = async (value) => {
    const apiDetails = await getVendorsList(value);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setVendors(data?.entities?.rows || []);
  };

  const [form, setForm] = useState({
    wheelLogDetails: {
      serviceDate: null,
      ododmeterReading: null,
      cityId: null,
      reportAttachments: null,
      attachments: [],
      description: null,
      vendorId: null,
      issueId: null,
      vendorName: null,
      vendorMobile: null,
      vendorEmail: null,
      isRotated: null,
      isAlignmentDone: null,
      isBalancingDone: null,
      isPaymentPending: null,
      costToCompany: null,
    },
  });

  const handleServiceAttachment = async (files) => {
    const res = await uploadmutiplefile(files, "vehicles", "vehicle");

    const uploaded = res?.uploaded;

    setForm((prev) => ({
      ...prev,
      wheelLogDetails: {
        ...prev.wheelLogDetails,
        reportAttachments: [
          ...(prev.wheelLogDetails.reportAttachments || []),
          ...uploaded,
        ],
      },
    }));
  };

  const handleServiceChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      wheelLogDetails: {
        ...prev.wheelLogDetails,
        [field]: value,
      },
    }));
  };

  const handleSubmit = async () => {
    const { wheelLogDetails } = form;

    if (!wheelLogDetails?.cityId) {
      return toast.error("Please select City");
    }

    if (!wheelLogDetails?.serviceDate) {
      return toast.error("Please Service Date");
    }

    if (!wheelLogDetails?.odometerReading) {
      return toast.error("Please enter odometer reading");
    }

    if (!wheelLogDetails?.vendorId) {
      return toast.error("Please Select Vendor");
    }

    const payload = {
      serviceDate: form?.wheelLogDetails?.serviceDate,
      ododmeterReading: form?.wheelLogDetails?.odometerReading,
      cityId: form?.wheelLogDetails?.cityId,
      reportAttachments: JSON.stringify(
        form?.wheelLogDetails?.reportAttachments,
      ),
      attachments: form?.wheelLogDetails?.attachments,
      description: form?.wheelLogDetails?.description,
      vendorId: form?.wheelLogDetails?.vendorId,
      issueId: form?.wheelLogDetails?.issueId,
      vendorName: form?.wheelLogDetails?.vendorName,
      vendorMobile: form?.wheelLogDetails?.vendorMobile,
      vendorEmail: form?.wheelLogDetails?.vendorEmail,
      isRotated: form?.wheelLogDetails?.isRotated,
      isAlignmentDone: form?.wheelLogDetails?.isAlignmentDone,
      isBalancingDone: form?.wheelLogDetails?.isBalancingDone,
      isPaymentPending: form?.wheelLogDetails?.isPaymentPending,
      costToCompany: parseFloat(form?.wheelLogDetails?.costToCompany) || 0,
      vehicleId: selectedRow?.id,
    };

    try {
      const res = await fetch(`${apiUrl}/api/wheelalignmentlogs`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.statusCode === "0100") {
        toast.success("Wheel Alignment Log Added Successfully 🎉");

        setForm({
          wheelLogDetails: {
            serviceDate: "",
            odometerReading: "",
            cityId: "",
            reportAttachments: [],
            attachments: [],
            description: "",
            vendorId: "",
            issueId: "",
            vendorName: "",
            vendorMobile: "",
            vendorEmail: "",
            isRotated: "",
            isAlignmentDone: "",
            isBalancingDone: "",
            isPaymentPending: "",
            costToCompany: "",
          },
        });

        setActiveStep(0);
        await getClutchLogs(selectedRow?.id);
      }
    } catch (err) {
      console.log(err);
      toast.error("Something went wrong");
    }
  };

  useEffect(() => {
    if (selectedRow?.id) {
      getClutchLogs(selectedRow?.id);
    }
  }, [selectedRow]);

  const getClutchLogs = async (vehicleID, page = 0, pageSize = 20) => {
    const limit = pageSize;
    const offset = page * pageSize;

    try {
      setLoading(true);

      const response = await fetch(
        `${apiUrl}/api/wheelalignmentlogs?limit=${limit}&offset=${offset}&vehicleId=${vehicleID}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );

      const data = await response.json();

      console.log("Wheel Alignment Logs Data:", data?.entities?.rows);

      if (data?.statusCode === "0100") {
        setClutchLogs(data?.entities?.rows || []);
        setTotalCount(data?.entities?.count || 0);
      }

      return data;
    } catch (error) {
      console.error("Error fetching NRK listings:", error);
    } finally {
      setLoading(false);
    }
  };

  const rows =
    (clutchLogs &&
      clutchLogs?.map((item) =>
        createData(
          item?.reportAttachments,
          cities[item?.cityId],
          item?.serviceDate,
          item?.ododmeterReading,
          item?.description,
          item?.isRotated ? "True" : "False",
          item?.isAlignmentDone ? "True" : "False",
          item?.isBalancingDone ? "True" : "False",
          item?.isPaymentPending ? "True" : "False",
          item?.costToCompany || 0,
          item?.totalCost || 0,
          myIssues.filter((issue) => issue?.id === item?.issueId)[0]?.code,
          vendors.filter((vendor) => vendor?.id === item?.vendorId)[0]?.name,
          item,
        ),
      )) ||
    [];

  const getFileType = (url = "") => {
    const ext = url.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "webp", "gif", "avif", "svg"].includes(ext))
      return "image";
    if (["mp4", "webm", "ogg"].includes(ext)) return "video";
    if (ext === "pdf") return "pdf";
    if (ext === "heic") return "heic";
    if (["doc", "docx", "xls", "xlsx"].includes(ext)) return "doc";

    return "file";
  };

  return (
    <>
      <div className="flex justify-between p-6 mt-6">
        <h1 className="text-lg font-semibold">Add Wheel Alignment Log</h1>

        {hideTextfields ? (
          <CloseIcon
            onClick={() => setHideTestFields(false)}
            className="cursor-pointer"
          />
        ) : (
          <AddCircleOutlineIcon
            onClick={() => setHideTestFields(true)}
            className="cursor-pointer"
          />
        )}
      </div>

      {hideTextfields && (
        <div className="p-6">
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((step) => (
              <Step key={step}>
                <StepLabel>{step}</StepLabel>
              </Step>
            ))}
          </Stepper>

          {/* STEP 1 */}

          {activeStep === 0 && (
            <div className="grid grid-cols-3 gap-6 mt-6">
              <FormControl>
                <InputLabel>Select City</InputLabel>
                <Select
                  value={form.wheelLogDetails.cityId}
                  label="Clutch Work Type"
                  onChange={(e) =>
                    handleServiceChange("cityId", e.target.value)
                  }
                >
                  {Object.entries(cities).map(([k, v]) => (
                    <MenuItem key={k} value={k}>
                      {v}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField
                type="date"
                label="Service Date"
                InputLabelProps={{ shrink: true }}
                value={form.wheelLogDetails.serviceDate}
                onChange={(e) =>
                  handleServiceChange("serviceDate", e.target.value)
                }
              />

              <TextField
                type="number"
                label="Odometer Reading"
                InputLabelProps={{ shrink: true }}
                value={form.wheelLogDetails.odometerReading}
                onChange={(e) =>
                  handleServiceChange("odometerReading", e.target.value)
                }
              />

              <TextField
                type="text"
                label="Description"
                InputLabelProps={{ shrink: true }}
                value={form.wheelLogDetails.description}
                onChange={(e) =>
                  handleServiceChange("description", e.target.value)
                }
              />

              <FormControl fullWidth>
                <InputLabel>Select Vendor</InputLabel>
                <Select
                  value={form.wheelLogDetails.vendorId}
                  label="Select Vendor"
                  onChange={(e) =>
                    handleServiceChange("vendorId", e.target.value)
                  }
                >
                  {vendors?.map((vendor) => (
                    <MenuItem key={vendor.id} value={vendor.id}>
                      {vendor.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel>Is Rotated</InputLabel>
                <Select
                  value={form.wheelLogDetails.isRotated}
                  label="Is Rotated"
                  onChange={(e) =>
                    handleServiceChange("isRotated", e.target.value)
                  }
                >
                  <MenuItem key={true} value={true}>
                    True
                  </MenuItem>
                  <MenuItem key={false} value={false}>
                    False
                  </MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel>Is Alignment Done</InputLabel>
                <Select
                  value={form.wheelLogDetails.isAlignmentDone}
                  label="Is Alignment Done"
                  onChange={(e) =>
                    handleServiceChange("isAlignmentDone", e.target.value)
                  }
                >
                  <MenuItem key={true} value={true}>
                    True
                  </MenuItem>
                  <MenuItem key={false} value={false}>
                    False
                  </MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel>Is Balancing Done</InputLabel>
                <Select
                  value={form.wheelLogDetails.isBalancingDone}
                  label="Is Balancing Done"
                  onChange={(e) =>
                    handleServiceChange("isBalancingDone", e.target.value)
                  }
                >
                  <MenuItem key={true} value={true}>
                    True
                  </MenuItem>
                  <MenuItem key={false} value={false}>
                    False
                  </MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel>Is Payment Pending</InputLabel>
                <Select
                  value={form.wheelLogDetails.isPaymentPending}
                  label="Is Payment Pending"
                  onChange={(e) =>
                    handleServiceChange("isPaymentPending", e.target.value)
                  }
                >
                  <MenuItem key={true} value={true}>
                    True
                  </MenuItem>
                  <MenuItem key={false} value={false}>
                    False
                  </MenuItem>
                </Select>
              </FormControl>

              <TextField
                type="number"
                label="Cost to Company"
                InputLabelProps={{ shrink: true }}
                value={form.wheelLogDetails.costToCompany}
                onChange={(e) =>
                  handleServiceChange("costToCompany", e.target.value)
                }
              />

              <FormControl fullWidth>
                <InputLabel>Select Issue</InputLabel>
                <Select
                  value={form.wheelLogDetails.issueId}
                  label="Select Vendor"
                  onChange={(e) =>
                    handleServiceChange("issueId", e.target.value)
                  }
                >
                  {myIssues?.map((issue) => (
                    <MenuItem key={issue.id} value={issue.id}>
                      {issue.code}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <div className="col-span-3">
                <label className="font-semibold mb-2 block">
                  Wheel Alignment Attachments
                </label>

                <Button component="label" variant="outlined">
                  Upload Files
                  <input
                    hidden
                    type="file"
                    multiple
                    onChange={(e) => handleServiceAttachment(e.target.files)}
                  />
                </Button>

                <div className="flex gap-3 mt-3 flex-wrap">
                  {form.wheelLogDetails.reportAttachments?.map((img, i) => (
                    <img
                      key={i}
                      src={img?.url}
                      className="w-20 h-20 object-cover rounded border"
                    />
                  ))}
                </div>
              </div>
            </div>
          )}

          <div className="flex justify-end gap-4 mt-6">
            {activeStep > 0 && (
              <Button onClick={() => setActiveStep(activeStep - 1)}>
                Back
              </Button>
            )}

            {activeStep < steps.length - 1 && (
              <Button
                variant="contained"
                onClick={() => setActiveStep(activeStep + 1)}
              >
                Next
              </Button>
            )}

            {activeStep === steps.length - 1 && (
              <Button variant="contained" onClick={handleSubmit}>
                Submit
              </Button>
            )}
          </div>
        </div>
      )}

      <div className="p-4">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Attachments</TableCell>
              {/* <TableCell>City</TableCell> */}
              <TableCell>Service Date</TableCell>
              <TableCell>Odometer Reading</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Is Rotated</TableCell>
              <TableCell>Is Alignment Done</TableCell>
              <TableCell>Is Balancing Done</TableCell>
              {/* <TableCell>Is Payment Pending</TableCell> */}
              <TableCell>Cost to Company</TableCell>
              <TableCell>Total Cost</TableCell>
              <TableCell>Action</TableCell>
              {/* <TableCell>Issue Id</TableCell> */}
              {/* <TableCell>Vendor Name</TableCell> */}
              <TableCell />
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.length ? (
              rows.map((r, index) => (
                <React.Fragment key={index}>
                  <TableRow
                    onClick={() => {
                      const navigate = `/workorder?orderid=${r?.rawData?.serviceLogId}&display=true`;
                      window.open(navigate, "_blank");
                    }}
                  >
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => setOpen(open === index ? -1 : index)}
                      >
                        {open === index ? (
                          <KeyboardArrowUpIcon />
                        ) : (
                          <KeyboardArrowDownIcon />
                        )}
                      </IconButton>
                    </TableCell>
                    {/* <TableCell>{r.city}</TableCell> */}
                    <TableCell>{r.serviceDate}</TableCell>
                    <TableCell>{r.ododmeterReading}</TableCell>
                    <TableCell
                      style={{
                        color: "green",
                        fontWeight: "bold",
                      }}
                    >
                      {r.description}
                    </TableCell>
                    <TableCell
                      style={{
                        backgroundColor:
                          r.isRotated === "True" ? "lightgreen" : "lightcoral",
                        color: "black", // optional, for text readability
                      }}
                    >
                      {r.isRotated}
                    </TableCell>
                    <TableCell
                      style={{
                        backgroundColor:
                          r.isAlignmentDone === "True"
                            ? "lightgreen"
                            : "lightcoral",
                        color: "black",
                      }}
                    >
                      {r.isAlignmentDone}
                    </TableCell>
                    <TableCell
                      style={{
                        backgroundColor:
                          r.isBalancingDone === "True"
                            ? "lightgreen"
                            : "lightcoral",
                        color: "black", // optional, for text readability
                      }}
                    >
                      {r.isBalancingDone}
                    </TableCell>
                    {/* <TableCell
                    style={{
                        backgroundColor:
                          r.isPaymentPending === "True" ? "lightgreen" : "lightcoral",
                        color: "black", // optional, for text readability
                      }}>{r.isPaymentPending}</TableCell> */}
                    <TableCell>{r.costToCompany}</TableCell>
                    <TableCell>{r.totalCost}</TableCell>
                    {r?.rawData?.serviceLogId &&
                    r?.rawData?.serviceLogId !== 0 ? (
                      <TableCell>
                        <Button
                          onClick={() => {
                            const navigate = `/workorder?orderid=${r?.rawData?.serviceLogId}&display=true`;
                            window.open(navigate, "_blank");
                          }}
                        >
                          View
                        </Button>
                      </TableCell>
                    ) : null}
                    {/* <TableCell>{r.issueId}</TableCell>
                    <TableCell>{r.vendorName}</TableCell> */}
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={9} sx={{ p: 0 }}>
                      <Collapse in={open === index}>
                        <Box>
                          <TableCell>
                            <div className="flex gap-2 flex-wrap">
                              <div className="flex gap-2 flex-wrap">
                                {r?.attachments &&
                                  JSON.parse(r?.attachments)?.map(
                                    (item, index) => {
                                      const url =
                                        typeof item === "string"
                                          ? item
                                          : item?.url;
                                      if (!url) return null;

                                      const type = getFileType(url);

                                      return (
                                        <div
                                          key={index}
                                          className="border rounded-xl p-3 shadow hover:shadow-lg transition bg-white flex flex-col items-center justify-between gap-3"
                                        >
                                          {/* Preview */}
                                          <div
                                            onClick={() => {
                                              handleImageOpen(url);
                                            }}
                                            className="flex items-center justify-center"
                                          >
                                            {type === "image" && (
                                              <img
                                                src={url}
                                                alt={"Preview"}
                                                className="w-28 h-24 object-cover rounded-lg cursor-pointer"
                                              />
                                            )}

                                            {type === "heic" && (
                                              <div>
                                                <HeicPreview
                                                  url={url}
                                                  alt={"Preview"}
                                                  className="w-28 h-24 object-cover rounded-lg cursor-pointer"
                                                />
                                              </div>
                                            )}

                                            {type === "video" && (
                                              <video
                                                src={url}
                                                controls
                                                className="w-28 h-24 rounded-lg"
                                              />
                                            )}

                                            {type === "pdf" && (
                                              <FileText
                                                size={36}
                                                className="text-red-600"
                                              />
                                            )}

                                            {type === "doc" && (
                                              <File
                                                size={36}
                                                className="text-blue-600"
                                              />
                                            )}

                                            {type === "file" && (
                                              <FileImage
                                                size={36}
                                                className="text-gray-600"
                                              />
                                            )}
                                          </div>

                                          <p>{item?.fileExt}</p>

                                          {/* Download Button */}
                                          <a
                                            href={url}
                                            target="_blank"
                                            download
                                            className="w-full text-center text-sm font-medium px-3 py-1.5 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-800 transition"
                                          >
                                            ⬇ Download
                                          </a>
                                        </div>
                                      );
                                    },
                                  )}
                              </div>
                            </div>
                          </TableCell>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={10} // 👈 adjust based on total columns
                  align="center"
                  sx={{ fontWeight: "bold", py: 3 }}
                >
                  No Wheel Alignment Log Details Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </>
  );
};

export default Wheelalignmentlogs;
